import { render, staticRenderFns } from "./FormDiv.vue?vue&type=template&id=0ae1224f&scoped=true&"
import script from "./FormDiv.vue?vue&type=script&lang=ts&"
export * from "./FormDiv.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ae1224f",
  null
  
)

export default component.exports